import script from "./resetSuccessfull.vue?vue&type=script&setup=true&lang=js"
export * from "./resetSuccessfull.vue?vue&type=script&setup=true&lang=js"

import "./resetSuccessfull.vue?vue&type=style&index=0&id=547ad3ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547ad3ae"]])

export default __exports__